/* ToolbarColorSwatch.tsx generated by @compiled/babel-plugin v0.38.1 */
import "./ToolbarColorSwatch.compiled.css";
import { ax, ix } from "@compiled/react/runtime";
import React from 'react';
import { Box } from '@atlaskit/primitives/compiled';
var styles = {
  colorSwatch: "_19it7r9e _2rko12b0 _1e0c1txw _1bah1h6o _4cvr1h6o _1bsbgktf _4t3igktf _18u0r5cr _2hwxr5cr"
};
export var ToolbarColorSwatch = function ToolbarColorSwatch(_ref) {
  var children = _ref.children,
    highlightColor = _ref.highlightColor;
  return /*#__PURE__*/React.createElement(Box, {
    xcss: styles.colorSwatch,
    style: {
      backgroundColor: highlightColor
    }
  }, children);
};